import type { RefObject } from "react";

export function attachedPillElement<T extends HTMLElement>(
  ref: RefObject<T | null>,
): T {
  if (ref.current === null)
    throw new Error("The active pill control must be attached.");

  return ref.current;
}
